<div class="kt-portlet" cdkDrag cdkDragRootElement=".cdk-overlay-pane" [ngClass]="class" #portlet>
  <ng-content></ng-content>
</div>
